import { lazy } from 'react'
import { renderWithLazyLoading } from '../../../WebAppLoading'

const PipelineHome = lazy(() => import('../../../../routes/pipeline'))

const PipelineHomeLazyLoading = renderWithLazyLoading(<PipelineHome />, true)

export default PipelineHomeLazyLoading
